var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "最大值" } },
        [
          _c("el-input-number", {
            attrs: { min: 1, max: 20, placeholder: "最大值" },
            model: {
              value: _vm.activeData.max,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "max", $$v)
              },
              expression: "activeData.max",
            },
          }),
        ],
        1
      ),
      _vm.activeData["allow-half"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "允许半选" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.activeData["allow-half"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "allow-half", $$v)
                  },
                  expression: "activeData['allow-half']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "辅助文字" } },
        [
          _c("el-switch", {
            on: { change: _vm.rateTextChange },
            model: {
              value: _vm.activeData["show-auxiliary-text"],
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "show-auxiliary-text", $$v)
              },
              expression: "activeData['show-auxiliary-text']",
            },
          }),
        ],
        1
      ),
      _vm.activeData["show-auxiliary-text"]
        ? [
            _c(
              "el-form-item",
              { attrs: { label: "左边文字" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "10" },
                  model: {
                    value: _vm.activeData.textLeft,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "textLeft", $$v)
                    },
                    expression: "activeData.textLeft",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "中间文字" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "10" },
                  model: {
                    value: _vm.activeData.textCenter,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "textCenter", $$v)
                    },
                    expression: "activeData.textCenter",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "右边文字" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "10" },
                  model: {
                    value: _vm.activeData.textRight,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "textRight", $$v)
                    },
                    expression: "activeData.textRight",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.activeData["show-score"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "显示分数" } },
            [
              _c("el-switch", {
                on: { change: _vm.rateScoreChange },
                model: {
                  value: _vm.activeData["show-score"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "show-score", $$v)
                  },
                  expression: "activeData['show-score']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData["show-stops"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "显示间断点" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.activeData["show-stops"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "show-stops", $$v)
                  },
                  expression: "activeData['show-stops']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }